export function isValidDate(date: string) {
    if (! /^\d\d\/\d\d\/\d\d\d\d$/.test(date)) {
        return false;
    }
    const parts = date.split('/').map((p) => parseInt(p, 10));
    parts[0] -= 1;
    const d = new Date(parts[2], parts[0], parts[1]);
    return d.getMonth() === parts[0] && d.getDate() === parts[1] && d.getFullYear() === parts[2];
}

export function validateEmail(email: string) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}




export type ValidatorType = {
    type: string,
    val: any
}

const VALIDATOR_TYPE_REQUIRE = 'REQUIRE';
const VALIDATOR_TYPE_MINLENGTH = 'MINLENGTH';
const VALIDATOR_TYPE_MAXLENGTH = 'MAXLENGTH';
const VALIDATOR_TYPE_MIN = 'MIN';
const VALIDATOR_TYPE_MAX = 'MAX';
const VALIDATOR_TYPE_EMAIL = 'EMAIL';
const VALIDATOR_TYPE_FILE = 'FILE';
const VALIDATOR_VALID_DATE = 'DATE';
const VALIDATOR_MATCH_VALUES = "MATCH_VALUES";
const VALIDATOR_PASSWORD_PATTREN = "PASSWORD_PATTREN";




export const VALIDATOR_REQUIRE = () => ({
    type: VALIDATOR_TYPE_REQUIRE
});

export const VALIDATOR_EMAIL = () => ({
    type: VALIDATOR_TYPE_EMAIL
});

export const VALIDATOR_PASSWORD = () => ({
    type: VALIDATOR_PASSWORD_PATTREN
});

export const VALIDATOR_MINLENGTH = (val: number) => ({
    type: VALIDATOR_TYPE_MINLENGTH,
    val: val
});

export const VALIDATOR_MAXLENGTH = (val: number) => ({
    type: VALIDATOR_TYPE_MAXLENGTH,
    val: val
});

export const VALIDATOR_MIN = (val: number) => ({
    type: VALIDATOR_TYPE_MIN,
    val: val
});

export const VALIDATOR_MAX = (val: number) => ({
    type: VALIDATOR_TYPE_MAX,
    val: val
});

export const VALIDATOR_DATE = () => ({
    type: VALIDATOR_VALID_DATE
})

export const VALIDATOR_MATCHING_VALUES = (val: string) => ({
    type: VALIDATOR_MATCH_VALUES,
    val: val
})



export const validate = (value: any, validtors: any) => {
    let isValid = true;
    let errorMessage = '';
    for (const validator of validtors) {
        if (validator.type === VALIDATOR_TYPE_REQUIRE) {
            isValid = isValid && value.trim().length > 0;
        }
        if (validator.type === VALIDATOR_TYPE_MINLENGTH) {
            isValid = isValid && value.trim().length >= validator.val;
        }
        if (validator.type === VALIDATOR_TYPE_MAXLENGTH) {
            isValid = isValid && value.trim().length <= validator.val;
        }
        if (validator.type === VALIDATOR_TYPE_MIN) {
            isValid = isValid && value >= validator.val;
        }
        if (validator.type === VALIDATOR_TYPE_MAX) {
            isValid = isValid && value <= validator.val;
        }
        if (validator.type === VALIDATOR_TYPE_EMAIL) {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            isValid = isValid && re.test(String(value).toLowerCase());
        }
        if (validator.type === VALIDATOR_DATE) {
            if (! /^\d\d\/\d\d\/\d\d\d\d$/.test(value)) {
                return false;
            }
            const parts = value.split('/').map((p: any) => parseInt(p, 10));
            parts[0] -= 1;
            const d = new Date(parts[2], parts[0], parts[1]);
            isValid = isValid && d.getMonth() === parts[0] && d.getDate() === parts[1] && d.getFullYear() === parts[2];

        }
        if (validator.type === VALIDATOR_MATCH_VALUES) {
            isValid = isValid && value === validator.val;
        }

        if (validator.type === VALIDATOR_PASSWORD_PATTREN) {

            const re = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d\W_]{6,}$/;

            isValid = isValid && re.test(String(value));
        }

    }
    return isValid;
}